"use client";

import { Button, LoadingSpinner } from "@wtc/ui";
import { HardDrive } from "lucide-react";
import type {
  Attachment,
  ClientFolder,
  UploadResults,
} from "./SaveAttachmentsToGoogleDriveModal.types";

interface SaveAttachmentsModalActionsProps {
  attachments: Attachment[];
  hasAnyDriveAccess: boolean;
  isLoading: boolean;
  isUploading: boolean;
  onClose: () => void;
  onUpload: () => void;
  selectedAttachmentCount: number;
  selectedClient: ClientFolder | null;
  uploadResults: UploadResults | null;
}

export function SaveAttachmentsModalActions({
  attachments,
  hasAnyDriveAccess,
  isLoading,
  isUploading,
  onClose,
  onUpload,
  selectedAttachmentCount,
  selectedClient,
  uploadResults,
}: SaveAttachmentsModalActionsProps) {
  const canShowUploadButton = !uploadResults && attachments && attachments.length > 0;

  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button variant="outline" onClick={onClose} disabled={isUploading || isLoading}>
        {uploadResults ? "Close" : "Cancel"}
      </Button>
      {canShowUploadButton && (
        <Button
          onClick={onUpload}
          disabled={
            !selectedClient ||
            isUploading ||
            isLoading ||
            !hasAnyDriveAccess ||
            selectedAttachmentCount === 0
          }
        >
          {isUploading ? (
            <>
              <LoadingSpinner className="h-4 w-4 mr-2" />
              Uploading...
            </>
          ) : (
            <>
              <HardDrive className="h-4 w-4 mr-2" />
              Upload {selectedAttachmentCount} Attachment
              {selectedAttachmentCount !== 1 ? "s" : ""}
            </>
          )}
        </Button>
      )}
    </div>
  );
}
